import { FormArray, FormControl, FormGroup } from '@angular/forms';
import { AuthenticationMethodsSMSSchema } from './model';
import { atLeastOneGroupValidator } from '../authentication-method-policy-utlity';

export function initAuthenticationMethodsSMSForm(schema: AuthenticationMethodsSMSSchema): FormGroup {
    const includedGroups = schema.properties?.includeTargets?.items?.oneOf;
    const includedGroupsFormArray = new FormArray([]);

    if (includedGroups?.length > 0) {
        includedGroups.forEach((group) => {
            const groupControl = new FormGroup({
                id: new FormControl(group.properties.id.const),
                isUsableForSignIn: new FormControl(group.properties?.isUsableForSignIn?.const ?? false),
            });
            includedGroupsFormArray.push(groupControl);
        });
    } else {
        // Default to "all users" if no groups are specified
        const defaultGroupControl = new FormGroup({
            id: new FormControl('all_users'),
            isUsableForSignIn: new FormControl(false),
        });
        includedGroupsFormArray.push(defaultGroupControl);
    }

    const formGroup = new FormGroup({
        state: new FormControl(schema.properties.state.const),

        includeTargets: new FormGroup(
            {
                includedGroups: includedGroupsFormArray,

                groupInclusion: new FormControl(
                    schema.properties?.includeTargets?.items?.oneOf?.some(
                        (res) => res?.properties?.id?.const !== 'all_users',
                    ) ?? false,
                ),
            },
            [atLeastOneGroupValidator()],
        ),

        excludeTargets: new FormControl(
            schema.properties?.excludeTargets?.items?.oneOf?.map((res) => res.properties.id.const) || [],
        ),
    });

    // Re-validate includeTargets when includedGroups changes
    const includeTargetsGroup = formGroup.get('includeTargets') as FormGroup;
    const includedGroupsArray = includeTargetsGroup?.get('includedGroups') as FormArray;
    if (includedGroupsArray) {
        includedGroupsArray.valueChanges.subscribe(() => {
            includeTargetsGroup?.updateValueAndValidity({ emitEvent: false });
        });
    }

    // Re-validate includeTargets when state changes
    formGroup.get('state')?.valueChanges.subscribe(() => {
        includeTargetsGroup?.updateValueAndValidity({ emitEvent: false });
    });

    return formGroup;
}
